<template>
  <modal :show="show" @close="closeModal">
    <div class="box">
      <div slot="header">
        Không thể xóa kiểu nguồn
      </div>
      
      <div class="content source-type-dependency-warning-content">
        <p class="source-type-dependency-warning-message">{{ warningMessage }}</p>
        
        <div v-if="dataInputNames.length > 0" class="dependency-section">
          <strong>DataInput:</strong>
          <ul class="dependency-list">
            <li v-for="name in dataInputNames" :key="name" class="dependency-item">
              {{ name }}
            </li>
          </ul>
        </div>
        
        <div v-if="forwarderNames.length > 0" class="dependency-section">
          <strong>Forwarder:</strong>
          <ul class="dependency-list">
            <li v-for="name in forwarderNames" :key="name" class="dependency-item">
              {{ name }}
            </li>
          </ul>
        </div>
      </div>

      <div slot="footer" class="field is-grouped is-grouped-right">
        <div class="control">
          <button 
            type="button" 
            class="button is-link"
            @click="closeModal"
          >
            Đóng
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from '@cyradar/ui'

/**
 * SourceTypeDependencyWarning Component
 * 
 * Displays a warning dialog when attempting to delete a source type that has dependencies.
 * Shows which DataInput and Forwarder configurations are using the source type.
 */
export default {
  name: 'SourceTypeDependencyWarning',
  components: {
    Modal
  },
  props: {
    /**
     * Controls the visibility of the modal
     */
    show: {
      type: Boolean,
      default: false
    },
    /**
     * List of DataInput names that reference the source type
     */
    dataInputNames: {
      type: Array,
      default: () => []
    },
    /**
     * List of Forwarder names that reference the source type
     */
    forwarderNames: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    /**
     * Generates the warning message based on dependencies
     */
    warningMessage() {
      return 'Kiểu nguồn này đang được sử dụng bởi các cấu hình sau và không thể xóa:'
    }
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    }
  },
  methods: {
    /**
     * Closes the modal and emits close event
     */
    closeModal() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.source-type-dependency-warning-content {
  max-height: 400px;
  overflow-y: auto;
}

.source-type-dependency-warning-message {
  font-weight: 600;
  margin-bottom: 1rem;
  color: #e74c3c;
}

.dependency-section {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #e74c3c;
}

.dependency-section strong {
  color: #2c3e50;
  display: block;
  margin-bottom: 0.5rem;
}

.dependency-list {
  margin: 0;
  padding-left: 1rem;
}

.dependency-item {
  margin-bottom: 0.25rem;
  color: #34495e;
  font-family: 'Courier New', monospace;
  background-color: #ecf0f1;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-block;
  margin-right: 0.5rem;
}
</style>
